import script from "./DateEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateEditor.vue?vue&type=script&lang=ts&setup=true"

import "./DateEditor.vue?vue&type=style&index=0&id=ea15a2ee&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/r1/a/_Build/release/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea15a2ee"]])

export default __exports__